import { Button, Form } from 'react-bootstrap';
import { useContext } from 'react';
import { GlobalContext } from '../Context/globalContext';
import { toast } from 'react-toastify';
import FirebaseApp, { auth, googleProvider } from '../firebase';
import { signInWithPopup, signOut } from 'firebase/auth';
import { findUserRole } from '../utils/auth';
import backgroundImg from "../Assets/img/bgi.png"

export const Login = () => {

    const globalContext = useContext(GlobalContext);

    const onSubmit = async (e) => {
        e.preventDefault();
        toast.dismiss();

        try {
            const res = await signInWithGoogle();
            if (!res?.email) return;

            globalContext.setLoader(true);
            const db = await FirebaseApp();
            const role = await findUserRole(db, res.email);

            if (!role) {
                toast.error('User with this email does not exist.');
                await firebaseLogout();
                globalContext.setLoggedIn(false);
                globalContext.setUserEmail('');
                globalContext.setUserRole('');
                return;
            }

            globalContext.setLoggedIn(true);
            globalContext.setUserEmail(res.email);
            globalContext.setUserRole(role);
            toast.success('Logged In Successfully.');
        } catch (err) {
            console.log('login error --->', err);
            toast.error('Unable to login. Please try again.');
        } finally {
            globalContext.setLoader(false);
        }
    }

    const firebaseLogout = async () => {
        try {
            await signOut(auth);
            console.log("User logged out");
        } catch (error) {
            console.error("Logout Error:", error.message);
        }
    };

    const signInWithGoogle = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            console.log("User signed in");
            return result.user
        } catch (error) {
            console.error("Google Sign-In Error:", error.message);
            return false
        }
    };


    return (
        <section className="w3l-workinghny-form" style={{ backgroundImage: `url(${backgroundImg})` }}>
            <div className="workinghny-form-grid">
                <div className="wrapper">
                    <div className="workinghny-block-grid">
                        <div className="workinghny-left-img align-end">
                            <img src={require('../Assets/img/2.png')} className="img-responsive" alt="img" />
                        </div>
                        <div className="form-right-inf">
                            <h1>LOGIN</h1>
                            <div className="login-form-content">
                                <Form className="signin-form">
                                    <Button className="btn btn-style mt-3" onClick={(e) => onSubmit(e)}>Sign in with Google</Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}
